define([
    "dojo/_base/kernel"
], function (kernel) {
    var utils = {
        detectIE: function () {
            var ua = window.navigator.userAgent;

            // Test values; Uncomment to check result …

            // IE 10
            // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

            // IE 11
            // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

            // IE 12 / Spartan
            // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

            // Edge (IE 12+)
            // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // Edge (IE 12+) => return version number
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
            }

            // other browser
            return false;
        },

        isDebugPage: function () {
            return location.href.indexOf("-debug") > 0;
        },

        /**
         * Adds an event listener and returns a method to remove the event listener.
         * @param {HTMLElement} node - node on which event listener needs to be added
         * @param {String} eventName - name of the event
         * @param {function} callback - event callback
         * @param {Boolean} useCapture - use capture phase
         * @returns {{remove: remove}} - function to remove the event listener
         */
        addEventListener: function (node, eventName, callback, useCapture) {
            useCapture = !!useCapture;
            node.addEventListener(eventName, callback, useCapture);
            return {
                remove: function () {
                    node.removeEventListener(eventName, callback, useCapture);
                }
            }
        },

        /**
         * Returns true if the locale is CJK.
         * @returns {boolean}
         */
        isCJKLocale: function () {
            return ["ko", "ko-kr", "ja-jp", "zh-cn"].indexOf(kernel.locale) > -1;
        },

        /**
         * Return true if the OS is Mac.
         * @returns {boolean}
         */
        isMac: function () {
            return window.navigator.userAgent.indexOf("Mac") > -1;
        },

        /**
         * Return true if the OS is Linux.
         * @returns {boolean}
         */
        isLinux: function () {
            return window.navigator.userAgent.indexOf("Linux") > -1;
        },

        /**
         * Return true if the OS is Unix.
         * @returns {boolean}
         */
        isUnix: function () {
            return window.navigator.userAgent.indexOf("X11") > -1;
        },

        /**
         * Return true if the OS is Windows.
         * @returns {boolean}
         */
        isWindows: function () {
            return window.navigator.userAgent.indexOf("Win") > -1;
        },
        
        OSConstants: {WINDOWS: "Windows", MAC: "Mac", LINUX: "Linux"},
        
        getOS: function () {
            return this.isMac() ? this.OSConstants.MAC : (this.isLinux() ? this.OSConstants.LINUX : (this.isWindows() ? this.OSConstants.WINDOWS : "Unknown"))
        },

        isObject: function (obj) {
            // Simply determine if obj is an Object type and could have properties
            return obj === Object(obj);
        },

        hasProperties: function (obj, propertyName) {
            if (!utils.isObject(obj)) {
                return false;
            }

            // Unlike "Object.hasOwnProperty()", "for...in"
            //     1. Works with "Object.create(null)" maps
            //     2. Will search up the prototype chain
            if (propertyName === undefined) {
                for (var prop in obj) {
                    return true;
                }
            } else if (typeof propertyName === 'string') {
                for (var property in obj) {
                    if (property === propertyName) {
                        return true;
                    }
                }
            } else if (propertyName instanceof Array) {
                var hasProp = 0;
                propertyName.forEach(function (propName) {
                    hasProp += !!utils.hasProperties(obj, propName);
                });
                return !!hasProp;
            }

            return false;
        }
    };

    return utils;
});
